// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"bbceb70e","766":"8e11c9ef","800":"41e387d1"}[chunkId] + ".chunk.css";
};